import { mapPriceFromArray } from '@utils';
import {
  ProductHit,
  Product,
} from './interfaces';
import { PRODUCT_TYPE } from '@constants';

export const mapAlgoliaProduct = (hit: ProductHit): Product => ({
  id: hit.id,
  name: hit.name,
  image: hit.images?.[0]?.url ?? '',
  price: mapPriceFromArray(hit.prices),
  productType: hit.productType?.name as unknown as PRODUCT_TYPE,
  matchingVariantId: +hit.objectID.split('-').pop()
});
